import type { ServiceResponse } from "./api.types";
import { privateAPI } from "./axios";

export interface TableDataParams {
  basePath: string;
  page: number;
  pageSize: number;
  sortKey?: string;
  sortDirection?: "asc" | "desc";
  fullNameSearchQuery?: string;
}

export async function fetchTableData<T = unknown>(
  params: TableDataParams,
): Promise<ServiceResponse<T>> {
  const {
    basePath,
    page,
    pageSize,
    sortKey,
    sortDirection,
    fullNameSearchQuery,
  } = params;

  const urlParams = new URLSearchParams();

  if (sortKey && sortDirection) {
    urlParams.append(
      "sort",
      `${sortDirection === "desc" ? "-" : ""}${sortKey}`,
    );
  }

  urlParams.append("page", (page + 1).toString());
  urlParams.append("pageSize", pageSize.toString());

  if (fullNameSearchQuery) {
    urlParams.append("filter[fullName]", fullNameSearchQuery);
  }

  const { data } = await privateAPI.get<ServiceResponse<T>>(
    `${basePath}?${urlParams.toString()}`,
  );

  return data;
}
